import { FC, useEffect } from 'react'
import { FrequencyResult } from '../../formComponents'
import { ModalSectionProps, RotaPatternModalType } from '../utils'
import { useRotaPatternDescription } from 'screens/Rostering/hooks/useRotaPatternDescription'

export const FrequencyResultSection: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ form, formData, type }) => {
  const hasTimeWindow = formData?.startTime && formData?.endTime

  const { generatePattern, isLoadingGenerate, generatePatternMessage } =
    useRotaPatternDescription({ type })

  const isFormTouched = !!form?.getFieldValue('patternStart')

  useEffect(() => {
    if (hasTimeWindow && isFormTouched) {
      generatePattern(formData as any)
    }
  }, [isFormTouched, formData])

  if (!hasTimeWindow || !generatePatternMessage) {
    return null
  }

  return (
    <FrequencyResult
      message={generatePatternMessage}
      isLoading={isLoadingGenerate}
    />
  )
}
